module.exports = __webpack_public_path__ + "static/media/1001655DO.6e5f9eef.jpg";